// CRA inyecta PUBLIC_URL desde package.json ("homepage": "/landing")
const normalizeBase = (base) => (base || '').replace(/\/$/, '');

export const APP_BASENAME = normalizeBase(process.env.PUBLIC_URL) || '/landing';

export const publicAsset = (path) => {
  const assetPath = path.startsWith('/') ? path : `/${path}`;
  const base = normalizeBase(process.env.PUBLIC_URL) || '/landing';
  return `${base}${assetPath}`;
};
